import React from 'react';
import { Box, Paper, Stack } from '@mui/material';

interface DataTableShellProps {
  toolbar?: React.ReactNode;
  children: React.ReactNode;
}

export const DataTableShell: React.FC<DataTableShellProps> = ({
  toolbar,
  children,
}) => (
  <Paper sx={{ overflow: 'hidden', minWidth: 0, maxWidth: '100%' }}>
    {toolbar && (
      <Stack sx={{ px: 2, py: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
        {toolbar}
      </Stack>
    )}
    {/* Allow wide tables to scroll horizontally instead of being clipped */}
    <Box sx={{ overflowX: 'auto', minWidth: 0, maxWidth: '100%' }}>{children}</Box>
  </Paper>
);
